import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import BobLoadingMask from '../../../components/BobLoadingMask';

import * as CompanyManagementActions from '../../../actions/companyManagementActions';

import classes from '../CreateEntityPage.module.css';

const defaultApplicationState = {};

const ApplicationSettings = ({
    activeNavCompany,
    applications,
    bobLoading,
    createCompanyApplication,
    currentUser,
    deleteCompanyApplication,
    fetchCompanyApplications,
    handleBackClick,
    selectedCompany,
    updateCompanyApplications,
    ...props
}) => {

    const [applicationState, setApplicationState] = useState(null);
    const [selectedApplication, setSelectedApplication] = useState();
    const [companyApps, setCompanyApps] = useState(null);

    useEffect(() => {
        const init = async () => {
            applications.forEach((application, index) => {
                if (application.name !== 'K2A Core') {
                    defaultApplicationState[application.name] = false;
                }
                else {
                    defaultApplicationState[application.name] = true;
                }
            });

            const activeApps = await fetchCompanyApplications(selectedCompany.id);
            setCompanyApps(activeApps);

            const registeredApps = applications.filter(app => activeApps.find(item => item.applicationId === app.id));

            registeredApps.forEach(app => {
                defaultApplicationState[app.name] = true;
            });

            setApplicationState({ ...defaultApplicationState });
        };

        if (currentUser.isSuperUser) init();
    }, [selectedCompany]);

    const handleSwitchUpdate = async application => {
        let updatedState = {...applicationState};
        if (currentUser.isSuperUser) {
            let updated = false;
            const selectedApplication = applications.find(app => app.name === application);
            if (!updatedState[application]) {
                updated = await createCompanyApplication(selectedCompany.id, selectedApplication.id);
            } else {
                const appToDelete = companyApps.find(ca => ca.applicationId === selectedApplication.id);
                if (appToDelete) { 
                    updated = await deleteCompanyApplication(selectedCompany.id, appToDelete.id);
                }
            }

            if (updated) {
                const activeApps = await fetchCompanyApplications(selectedCompany.id);
                setCompanyApps(activeApps);
                updatedState[application] = !updatedState[application];
                setApplicationState({ ...updatedState });
            }
        }
    };

    const handleRowClick = index => {
        setSelectedApplication(index);
    };

    const renderSettingsTitle = () => {
        switch (selectedApplication) {
            case 0:
                return 'BOB Settings';
            case 1:
                return 'Energy Print Settings';
            case 2:
                return 'Schedule Settings';
            case 3:
                return 'Mobile Settings';
            case 4:
                return 'K2A Core Settings';
            case 5:
                return 'Service Settings';
            default:
                return '';
        }
    };

    const renderApplicationSettings = () => {
        switch (selectedApplication) {
            case 0:
                return 'BOB Settings Panel';
            case 1:
                return 'Energy Print Settings Panel';
            case 2:
                return 'Schedule Settings Panel';
            case 3:
                return 'Mobile Settings Panel';
            case 4:
                return 'K2A Core Settings Panel';
            case 6:
                return 'Service Settings Panel';
            default:
                return '';
        }
    };

    const handleRoute = () => {
        handleBackClick();
    };

    return (
        <div className={classes.companyForm}>
            <div className={classes.companyDetailsHeaderRow}>
                Applications
            </div>
            <div className={classes.companySettingsHeaderRow}>
                {renderSettingsTitle()}
            </div>
            <div className={classes.companyDetailsPanel}>
                <div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.ApplicationHeader}>
                                    Application
                                </TableCell>
                                <TableCell className={classes.AccessHeader}>
                                    Access
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                applicationState ? 
                                    applications.map((application, index) => {
                                        const isAppK2ACore = application.name === 'K2A Core';
                                        return (
                                            <TableRow key={application.id} onClick={() => handleRowClick(index)} className={selectedApplication === index ? classes.SelectedTableRow : classes.TableRow}>
                                                <TableCell>
                                                    {application.name}
                                                </TableCell>
                                                <TableCell>
                                                    <Switch
                                                        color="default"
                                                        disabled={(!currentUser.isSuperUser && !applicationState[application.name]) || isAppK2ACore}
                                                        checked={applicationState[application.name]}
                                                        onChange={() => handleSwitchUpdate(application.name)}
                                                        name={application.name}
                                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                    : null
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
            <div className={classes.companySettingsPanel}>
                {renderApplicationSettings()}
            </div>
            <div className={classes.companyButtonsPanel}>
                <Button
                    className={classes.Button}
                    onClick={() => handleRoute()}
                    variant="contained"
                >
                    Cancel
                </Button>
            </div>
            {
                bobLoading.includes('CompanyApplicationUpdate') || bobLoading.includes('FetchCompanyApplications') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        applications:     state.companyManagement.applications,
        bobLoading:       state.bob.bobLoading,
        companies:        state.core.companies,
        currentUser:      state.currentUser
    };
};

const mapDispatchToProps = {
    ...CompanyManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationSettings);
